import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';

const TextReverserTool = () => {
  const [input, setInput] = useState('');
  const [mode, setMode] = useState('characters');

  const getReversed = () => {
    if (!input) return '';
    switch (mode) {
      case 'characters':
        return input.split('').reverse().join('');
      case 'words':
        return input.split(/(\s+)/).reverse().join('');
      case 'lines':
        return input.split('\n').reverse().join('\n');
      default:
        return input;
    }
  };

  const output = getReversed();

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('Reversed text copied!');
  };

  return (
    <div className="space-y-6" data-testid="text-reverser-tool">
      <div className="flex gap-2 flex-wrap">
        {['characters', 'words', 'lines'].map((m) => (
          <Button
            key={m}
            variant={mode === m ? 'default' : 'outline'}
            onClick={() => setMode(m)}
            size="sm"
          >
            Reverse {m.charAt(0).toUpperCase() + m.slice(1)}
          </Button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">Input Text</label>
          <Textarea
            placeholder="Enter text to reverse..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[200px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">Reversed Output</label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[200px] font-mono text-sm bg-muted/50"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyOutput} disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy Result
        </Button>
        <Button onClick={() => setInput(output)} variant="outline" disabled={!output}>
          <ArrowRightLeft className="w-4 h-4 mr-2" /> Swap
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default TextReverserTool;
